<template>
  <div class="main">
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="全局设置" name="global">
        <el-form :model="controlForm" label-width="200px" size="medium" v-loading="controlFormLoading">
          <el-scrollbar>
            <el-form-item label="是否启动新版打印">
              <el-switch v-model="controlForm.isLodopPrint" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
            </el-form-item>
            <el-form-item label="自定义打印备注">
              <div class="tips">
                <el-input type="textarea" autosize placeholder="请输入内容" v-model="controlForm.printRemark"></el-input>
                <div class="el-form-item__error">
                  自定义打印备注会显示在打印单据的最下面,如果需要显示，需要在模版设置中勾选显示打印备注
                </div>
              </div>
            </el-form-item>
            <el-form-item label="打印标题字体大小">
              <span>
                <el-input-number :min="0" placeholder="请输入打印标题字体大小,例如26" controls-position="right" :precision="0" v-model="controlForm.printHeadTitleSize"></el-input-number>
                <span class="append">px</span>
              </span>
            </el-form-item>
            <el-form-item label="打印内容字体大小">
              <span>
                <el-input-number :min="0" placeholder="请输入打印内容字体大小,例如14" controls-position="right" :precision="0" v-model="controlForm.printFontSize"></el-input-number>
                <span class="append">px</span>
              </span>
            </el-form-item>
            <el-form-item label="打印表格的高度">
              <span>
                <el-input-number :min="0" placeholder="请输入打印表格的高度,例如30" controls-position="right" :precision="0" v-model="controlForm.tableHeight"></el-input-number>
                <span class="append">px</span>
              </span>
            </el-form-item>
            <el-form-item label="布局方式">
              <el-radio-group v-model="controlForm.headerLayoutWay">
                <el-radio :label="'0'">流式布局</el-radio>
                <el-radio :label="'1'">表格布局</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否打印页码">
              <el-switch v-model="controlForm.isPrintPagesNumber" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
            </el-form-item>
            <el-form-item label="打印模式">
              <el-switch style="margin-right: 30px" v-model="controlForm.isPrintPage" active-text="分页打印" inactive-text="即打即停" active-value="Y" inactive-value="N" @change="isPrintPageChange"></el-switch>
              <el-checkbox v-if="controlForm.isPrintPage == 'Y'" v-model="controlForm.isPrintHead" true-label="Y" false-label="N">每页打印表头</el-checkbox>
              <el-checkbox v-if="controlForm.isPrintPage == 'Y'" v-model="controlForm.isPrintFooter" true-label="Y" false-label="N">每页打印表尾</el-checkbox>
              <span v-if="controlForm.isPrintPage == 'N'">
                <span class="append">底部留白高度</span>
                <el-input-number :min="0" style="width: 120px;" placeholder="底部留白高度" controls-position="right" :precision="0" v-model="controlForm.bottomLodopHeight"></el-input-number>
                <span class="append">mm</span>
              </span>
            </el-form-item>
            <el-form-item label="纸张设置">
              <el-select style="margin-right: 12px;" v-model="controlForm.pageSet" placeholder="请选择纸张大小" value-key="value" @change="pageSetChange($event, 'controlForm')">
                <el-option
                  v-for="item in pageSetList"
                  :key="item.value"
                  :label="item.text"
                  :value="item">
                </el-option>
              </el-select>
              <span>
                <span class="append">纸张宽度</span>
                <el-input-number :min="0" style="width: 120px;" :disabled="Boolean(controlForm.pageSet.value)" placeholder="纸张宽度" controls-position="right" :precision="0" v-model="controlForm.pageSet.width" @change="pageSetChangeWidth($event, 'controlForm')"></el-input-number>
                <span class="append">mm</span>
              </span>
              <span>
                <span class="append">纸张高度</span>
                <el-input-number :min="0" style="width: 120px;" :disabled="Boolean(controlForm.pageSet.value)" placeholder="纸张高度" controls-position="right" :precision="0" v-model="controlForm.pageSet.height" @change="pageSetChangeHeight($event, 'controlForm')"></el-input-number>
                <span class="append">mm</span>
              </span>
            </el-form-item>
            <el-form-item label="纸张边距">
              <span>
                <span class="append">左边距</span>
                <el-input-number :min="0" style="width: 120px;" placeholder="左边距" controls-position="right" :precision="0" v-model="controlForm.printLodopMarginLeft"></el-input-number>
                <span class="append">mm</span>
              </span>
              <span>
                <span class="append">上边距</span>
                <el-input-number :min="0" style="width: 120px;" placeholder="上边距" controls-position="right" :precision="0" v-model="controlForm.printLodopMarginTop"></el-input-number>
                <span class="append">mm</span>
              </span>
            </el-form-item>
            <el-form-item>
              <p style="text-align: center; transform: translateX(-100px);"><el-button type="primary" @click="saveSet">保存设置</el-button></p>
            </el-form-item>
          </el-scrollbar>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="模板设置" name="template" lazy>
        <el-container>
          <el-aside width="210px" v-loading="printHeadTemplateLoading">
            <el-form class="el-card templateForm" :model="templateForm" size="medium" label-position="top">
              <el-scrollbar>
                <el-form-item v-show="templateForm.headerLayoutWay === '1'" label="表头每行的列数">
                  <el-input-number :min="0" style="width: 100%;" placeholder="请输入表头每行的列数" controls-position="right" :precision="0" v-model="templateForm.headColspan"></el-input-number>
                </el-form-item>
                <el-form-item v-show="templateForm.headerLayoutWay === '1'" label="表尾每行的列数">
                  <el-input-number :min="0" style="width: 100%;" placeholder="请输入表尾每行的列数" controls-position="right" :precision="0" v-model="templateForm.footerColspan"></el-input-number>
                </el-form-item>
                <el-form-item label="单据标题">
                  <el-input style="width: 100%;" v-model="templateForm.titleName" placeholder="请输入单据标题" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="布局方式">
                  <el-radio-group v-model="templateForm.headerLayoutWay">
                    <el-radio :label="0">流式布局</el-radio>
                    <el-radio :label="1">表格布局</el-radio>
                  </el-radio-group>
                </el-form-item> -->
                <el-form-item label="是否显示打印时间">
                  <el-switch v-model="templateForm.isPrintTime" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
                <el-form-item v-if="templateForm.headerLayoutWay === '0'" label="打印时间的字体大小">
                  <el-input-number :min="0" style="width: 100%;" placeholder="请输入打印时间的字体大小" :precision="0" :controls="false" v-model="templateForm.timeFontSize"></el-input-number>
                </el-form-item>
                <el-form-item v-if="templateForm.headerLayoutWay === '0'" label="打印时间的间距">
                  <el-input-number :min="-1" style="width: 100%;" placeholder="请输入打印时间的间距" :precision="0" :controls="false" v-model="templateForm.timeSpace"></el-input-number>
                </el-form-item>
                <el-form-item label="打印时间显示的位置">
                  <div class="tips">
                    <el-select style="width: 100%;" v-model="templateForm.printTimePosition" placeholder="请选择打印时间显示的位置">
                      <el-option
                        v-for="(item, index) in 13"
                        :key="index"
                        :label="index"
                        :value="index">
                      </el-option>
                    </el-select>
                    <div class="el-form-item__error">
                      打印时间会根据设置的位置，在表头的相应位置显示
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="纸张设置">
                  <el-select style="width: 100%;" v-model="templateForm.pageSet" placeholder="请选择纸张大小" value-key="value" @change="pageSetChange($event, 'templateForm')">
                    <el-option
                      v-for="item in pageSetList"
                      :key="item.value"
                      :label="item.text"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="纸张宽度">
                  <el-input-number :min="0" style="width: 100%;" :disabled="Boolean(templateForm.pageSet.value)" placeholder="纸张宽度" controls-position="right" :precision="0" v-model="templateForm.pageSet.width" @change="pageSetChangeWidth($event, 'templateForm')"></el-input-number>
                </el-form-item>
                <el-form-item label="纸张高度">
                  <el-input-number :min="0" style="width: 100%;" :disabled="Boolean(templateForm.pageSet.value)" placeholder="纸张高度" controls-position="right" :precision="0" v-model="templateForm.pageSet.height" @change="pageSetChangeHeight($event, 'templateForm')"></el-input-number>
                </el-form-item>
                <el-form-item label="是否显示自定义备注">
                  <el-switch v-model="templateForm.isShowPrint" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
                <el-form-item v-if="templateForm.headerLayoutWay === '0'" label="打印备注的字体大小">
                  <el-input-number :min="0" style="width: 100%;" placeholder="请输入打印备注的字体大小" :precision="0" :controls="false" v-model="templateForm.remarkFontSize"></el-input-number>
                </el-form-item>
                <el-form-item label="是否显示支付方式">
                  <el-switch v-model="templateForm.isShowPay" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
              </el-scrollbar>
            </el-form>
          </el-aside>
          <el-main>
            <div class="mainTable">
              <el-card shadow="never">
                <span>单据类型：</span>
                <el-select style="width: 140px; margin: 0 10px;" size="medium" v-model="templateForm.printSetType" placeholder="请选择单据类型" @change="printSetTypeChange">
                  <el-option
                    v-for="item in printSetTypeList"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-button size="medium" type="primary" @click="useDefaultTemplate" :disabled="showCustomTips">使用默认模版</el-button>
                <el-button size="medium" type="primary" @click="onSubmit" :disabled="showCustomTips">保存设置</el-button>
                <el-button size="medium" type="primary" @click="onSubmit(1)" :disabled="showCustomTips">效果预览</el-button>
              </el-card>
              <div class="table" v-loading="tableLoading">
                <el-table size="mini" ref="centerTable" :data="tableList" border stripe style="width: 688px;" max-height="100%" height="100%" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}" row-key="id" :span-method="arraySpanMethod" @cell-click="tableCellClick">
                  <el-table-column width="50" prop="$index" label="序号">
                    <template slot-scope="{row}">
                      <span>{{row.tag ? row.tag : row.$index}}</span>
                      <span style="margin-left: 16px; color: #F56C6C;" v-if="row.tips">
                        {{row.tips}}
                      </span>
                      <span style="margin-left: 20px;" v-if="row.id === 'body'">
                        <el-radio-group v-model="templateForm.layoutType">
                          <el-radio :label="'1'">局左</el-radio>
                          <el-radio :label="'2'">局中</el-radio>
                          <el-radio :label="'3'">局右</el-radio>
                        </el-radio-group>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="printColumnName" label="字段名称" width="140">
                    <template slot-scope="{row, column}">
                      <div v-if="!row.isRoot && row.isPrintColumnName">
                        <el-input size="mini" style="width: 100%;" v-focus v-model="row.printColumnName" placeholder="请输入字段名称" @blur="inputBlur(row, column)"></el-input>
                      </div>
                      <span v-else>{{row.printColumnName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isshow" label="是否显示" width="110">
                    <template slot-scope="{row}">
                      <el-switch v-if="!row.isRoot" v-model="row.isshow" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="indexNum" label="显示顺序" :width="templateForm.headerLayoutWay === '0' ? '90': '140'">
                    <template slot-scope="{row, column}">
                      <div v-if="!row.isRoot && row.isIndexNum">
                        <el-input-number :min="0" size="mini" style="width: 100%;" v-focus v-model="row.indexNum" placeholder="请输入显示顺序" :controls="false" @blur="inputBlur(row, column)"></el-input-number>
                      </div>
                      <span v-else>{{row.indexNum}}</span>
                    </template>
                  </el-table-column>
                  <!-- 表格布局 -->
                  <el-table-column key="width" prop="width" label="宽度" width="120" v-if="templateForm.headerLayoutWay == 1">
                    <template slot-scope="{row, column}">
                      <div v-if="!row.isRoot && row.isWidth">
                        <el-input-number :min="0" size="mini" style="width: 100%;" v-focus v-model="row.width" :precision="0" placeholder="请输入宽度" :controls="false" @blur="inputBlur(row, column)"></el-input-number>
                      </div>
                      <span v-else>
                        <span>{{ row.width || 0 }}</span>
                        <!-- <span v-if="row.printColumnType != 'F'">{{row.width}}</span> -->
                        <!-- <span v-else>--</span> -->
                      </span>
                    </template>
                  </el-table-column>
                  <!-- 流式布局 -->
                  <el-table-column key="space" prop="width" label="宽度" width="80" v-else-if="templateForm.headerLayoutWay == 0">
                    <template slot-scope="{row, column}">
                      <div v-if="!row.isRoot && row.isWidth">
                        <el-input-number v-if="['H', 'F'].includes(row.printColumnType)" :min="-1" size="mini" style="width: 100%;" v-focus v-model="row.space" :precision="0" placeholder="请输入宽度" :controls="false" @blur="inputBlur(row, column)"></el-input-number>
                      </div>
                      <span v-else>
                        <span  v-if="['H', 'F'].includes(row.printColumnType)" >{{row.space || 0}}</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="templateForm.headerLayoutWay == '0'" prop="fontsize" label="字体大小" width="90">
                    <template slot-scope="{row, column}">
                      <div v-if="row.printColumnType == 'H' || row.printColumnType == 'F'">
                        <el-input-number v-if="!row.isRoot && row.isFontsize" :min="0" size="mini" style="width: 100%;" v-focus v-model="row.fontsize" :precision="0" placeholder="请输入字体大小" :controls="false" @blur="inputBlur(row, column, $event)"></el-input-number>
                        <span v-else>{{row.fontsize || 0}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isSignArea" label="是否签字字段" width="120">
                    <template slot-scope="{row}">
                      <el-switch v-if="!row.isRoot && row.printColumnType == 'F'" v-model="row.isSignArea" active-text="是" inactive-text="否" active-value="Y" inactive-value="N"></el-switch>
                      <span v-if="row.printColumnType != 'F'">--</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="preview" :style="{width: templateForm.printLodopWidth * 3.77 + 'px'}">
              <div class="previewLine" :style="{width: templateForm.printLodopWidth * 3.77 + 'px', height: templateForm.printLodopHeight * 3.77 + 'px'}"></div>
              <!-- 表头字段展示——流式布局 -->
              <div v-show="templateForm.headerLayoutWay === '0'" style="position: relative;padding: 2px 0 0 2px;z-index: 2;">
                <span v-for="item in headList" :key="item.id" style="display: inline-block;">
                  <span class="print-name">{{ item.printColumnName }}</span>
                  <span class="print-value">xxx</span>
                  <!-- <span style="display: inline-block;height: 30px;" :style="{width: item.nbspnum + 'em'}"></span> -->
                  <el-input-number :min="-1" size="mini" style="display: inline-block;width: 90px;padding: 0 10px" v-focus v-model="item.space" :precision="0" :controls="false" placeholder="请输入宽度" @blur="addWidthBlur(item, $event)"></el-input-number>
                </span>
              </div>
              <!-- 表头字段展示——表格布局 -->
              <el-descriptions v-show="templateForm.headerLayoutWay === '1'" size="mini" border :column="templateForm.headColspan">
                <el-descriptions-item v-for="item in headList" :key="item.id" :label="item.printColumnName" :width="item.width + 'px'">xxx</el-descriptions-item>
              </el-descriptions>
              <el-table ref="previewTable" size="mini" :data="previewTableList" border stripe style="width: 100%;" max-height="100%" height="200px" @header-dragend="headerDragend">
                <el-table-column width="50" type="index" :align="templateForm.layoutType === '2'? 'center' : templateForm.layoutType === '3' ? 'right': 'left'"></el-table-column>
                <el-table-column v-for="item in bodyList" :key="item.id" :label="item.printColumnName" :prop="item.printColumnValue" :width="item.width" :align="templateForm.layoutType === '2'? 'center' : templateForm.layoutType === '3' ? 'right': 'left'"></el-table-column>
              </el-table>
              <!-- 表尾字段展示——流式布局 -->
              <div v-show="templateForm.headerLayoutWay === '0'" style="position: relative;padding: 2px 0 0 2px;z-index: 2;">
                <span v-for="item in footerList" :key="item.id" style="display: inline-block;">
                  <span class="print-name">{{ item.printColumnName }}</span>
                  <span class="print-value">xxx</span>
                  <el-input-number :min="-1" size="mini" style="display: inline-block;width: 90px;padding: 0 10px" v-focus v-model="item.space" :precision="0" :controls="false" placeholder="请输入宽度" @blur="addWidthBlur(item, $event)"></el-input-number>
                </span>
              </div>
              <!-- 表尾字段展示——表格布局 -->
              <el-descriptions v-show="templateForm.headerLayoutWay === '1'" size="mini" border :column="templateForm.footerColspan">
                <el-descriptions-item v-for="item in footerList" :key="item.id" :label="item.printColumnName">xxx</el-descriptions-item>
              </el-descriptions>
            </div>
          </el-main>
        </el-container>
      </el-tab-pane>
      <el-tab-pane v-if="showCustomTips" label="当前使用了定制模板，本界面设置的模板不再生效！修改请联系管理员" name="" :disabled="true"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { titleCase } from '@/assets/js/common.js'
export default {
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').onfocus = function (e) {
          e.currentTarget.select()
        }
        el.querySelector('input').focus()
      }
    }
  },
  data() {
    return {
      activeName: 'global',
      controlFormLoading: false,
      controlForm: {
        isLodopPrint: 'N',
        printRemark: '',
        printHeadTitleSize: '',
        printFontSize: '',
        tableHeight: '',
        isPrintPagesNumber: 'N',
        isPrintPage: 'N',
        isPrintHead: 'N', // 每页是否打印表头
        isPrintFooter: 'N', // 每页是否打印表尾
        pageSet: {value: 1, text: 'A4(210*297mm)', width: 210, height: 297},
        printLodopWidth: 0,
        printLodopHeight: 0,
        bottomLodopHeight: 0,
        printLodopMarginLeft: 0,
        printLodopMarginTop: 0,
        headerLayoutWay: '0', // 0 流式布局 1表格布局
      },
      templateForm: {
        headColspan: 3,
        footerColspan: 3,
        titleName: '',
        isPrintTime: 'N',
        printTimePosition: 1,
        pageSet: {value: 1, text: 'A4(210*297mm)', width: 210, height: 297},
        printLodopWidth: 0,
        printLodopHeight: 0,
        isShowPrint: 'N',
        isShowPay: 'N',
        printSetType: 'PI',
        isNewPrint: 'Y',
        layoutType: '1',
        headerLayoutWay: '', // 0 流式布局 1表格布局
      },
      pageSetList: [
        {value: 0, text: '自定义', width: 0, height: 0},
        {value: 1, text: 'A4(210*297mm)', width: 210, height: 297},
        {value: 2, text: '二等分(216*140mm)', width: 216, height: 140},
        {value: 3, text: '三等分(216*93mm)', width: 216, height: 93},
      ],
      printSetTypeList: [
        {value: 'PI', text: '采购进货单'},
        {value: 'PIN', text: '采购进货单新'},
        {value: 'PO', text: '采购退货单'},
        {value: 'PON', text: '采购退货单新'},
        {value: 'SI', text: '销售出库单'},
        {value: 'OI', text: '销售订单'},
        {value: 'SO', text: '销售退货单'},
        {value: 'SON', text: '销售退货单新'},
        {value: 'OO', text: '销售退货订单'},
        {value: 'MV', text: '调拨单'},
        {value: 'CK', text: '盘点单'},
        {value: 'PS', text: '配送单'},
        {value: 'PSN', text: '配送单新'},
        {value: 'DH', text: '订货单'},
        {value: 'PPDH', text: '品牌订货单'},
        {value: 'HH', text: '还货单'},
        {value: 'HHD', text: '还货订单'},
        {value: 'ZCZ', text: '组拆装单'},
        {value: 'XFY', text: '现金费用单'},
        {value: 'QFY', text: '费用欠款单'},
        {value: 'CFY', text: '货物抵费用单'},
        {value: 'PFY', text: '普通费用单'},
        {value: 'VFY', text: '车辆费用'},
        {value: 'RFY', text: '人员费用'},
        {value: 'KFY', text: '库房费用'},
        {value: 'PZ', text: '记账凭证'},
        {value: 'SPR', text: '销售-退货价格报表'},
        {value: 'KFZR', text: '库房主账报表'},
        {value: 'DDYH', text: '订单余货'},
        {value: 'MDSKD', text: '门店收款单'},
        {value: 'SKD', text: '收款单详情'},
        {value: 'FKD', text: '付款单详情'},
        {value: 'PSSP', text: '装车打印'},
        {value: 'HZDY', text: '汇总打印'},
        {value: 'SIN', text: '销售出库单新'},
        {value: 'EHD', text: '换货订单'},
        {value: 'EHDS', text: '换货订单汇总'},
        {value: 'SJS', text: '上交款汇总'},
        {value: 'SJCS', text: '上交款客户汇总'},
        {value: 'SJXSD', text: '上交款明细'},
        {value: 'MDSKDN', text: '门店收款单新'},
        {value: 'BSD', text: '库存报损单'}
      ],
      tableLoading: false,
      printHeadTemplateLoading: false,
      showCustomTips: false,
      tableList: [
        {
          id: 'head',
          tag: '表头字段设置',
          tips: '',
          isRoot: true,
          children: []
        },
        {
          id: 'body',
          tag: '表格字段设置',
          tips: '',
          isRoot: true,
          children: []
        },
        {
          id: 'footer',
          tag: '表尾字段设置',
          tips: '',
          isRoot: true,
          children: []
        }
      ]
    }
  },
  watch: {
    '$store.state.power'(val) {
      this.toDoByPower(val)
    }
  },
  created() {
    this.toDoByPower(this.$store.state.power)
    this.getOverallSet()
  },
  computed: {
    headList() {
      let tempArr = []
      let arr = [...this.tableList[0].children]
      arr = arr.sort((a, b) => {
        return Number(a.indexNum) - Number(b.indexNum)
      })
      arr.forEach(item => {
        if (item.isshow == 'Y') {
          tempArr.push(item)
        }
      })
      return tempArr
    },
    bodyList() {
      let tempArr = []
      let arr = [...this.tableList[1].children]
      arr = arr.sort((a, b) => {
        return Number(a.indexNum) - Number(b.indexNum)
      })
      arr.forEach(item => {
        if (item.isshow == 'Y') {
          tempArr.push(item)
        }
      })
      return tempArr
    },
    previewTableList() {
      let tempitem = {}
      let arr = [...this.tableList[1].children]
      arr = arr.sort((a, b) => {
        return Number(a.indexNum) - Number(b.indexNum)
      })
      arr.forEach(item => {
        if (item.isshow == 'Y') {
          tempitem[item.printColumnValue] = item.printColumnName
        }
      })
      return [tempitem]
    },
    footerList() {
      let tempArr = []
      let arr = [...this.tableList[2].children]
      arr = arr.sort((a, b) => {
        return Number(a.indexNum) - Number(b.indexNum)
      })
      arr.forEach(item => {
        if (item.isshow == 'Y') {
          tempArr.push(item)
        }
      })
      return tempArr
    },
  },
  methods: {
    toDoByPower(power = {}) {
      let { isVuePage } = power
      console.log(isVuePage)
      if (isVuePage == 'Y') {
        this.printSetTypeList = this.printSetTypeList.filter(i => !['PI', 'PO', 'SI', 'SO', 'PS', 'ZCZ', 'XFY', 'QFY', 'PFY', 'VFY', 'RFY', 'KFY', 'PZ', 'SPR', 'KFZR', 'SKD', 'FKD' ].includes(i.value))
        this.templateForm.printSetType = 'PIN'
      }
    },
    handleTabClick() {
      if (this.activeName == 'global') {
        this.getOverallSet()
        this.showCustomTips = false
      } else {
        this.templateForm.headerLayoutWay = ''
        this.getTemplateType()
        this.getPrintHeadTemplate()
        // this.getPrintTemplate()
      }
    },
    isPrintPageChange(val) {
      if (val == 'N') {
        this.controlForm.isPrintHead = false
        this.controlForm.isPrintFooter = false
      }
    },
    pageSetChange({height, width}, tag) {
      this[tag].printLodopWidth = width
      this[tag].printLodopHeight = height
    },
    pageSetChangeWidth(width, tag) {
      this[tag].printLodopWidth = width
    },
    pageSetChangeHeight(height, tag) {
      this[tag].printLodopHeight = height
    },
    async getTemplateType() {
      const {data: res} = await this.$http.post('/Account/PrintSet/isCustomTemplate.html', this.Qs.stringify({
        printSetType: this.templateForm.printSetType || ''
      }))
      if (res.code != 'success') return this.$alert(res.msg, '提示', {
        confirmButtonText: '确定'
      })
      this.showCustomTips = res.result == 'Y'
      console.log(666, res.result)
    },
    printSetTypeChange() {
      this.tableList = [
        {
          id: 'head',
          tag: '表头字段设置',
          tips: '',
          isRoot: true,
          children: []
        },
        {
          id: 'body',
          tag: '表格字段设置',
          tips: '',
          isRoot: true,
          children: []
        },
        {
          id: 'footer',
          tag: '表尾字段设置',
          tips: '',
          isRoot: true,
          children: []
        }
      ]
      if(this.templateForm.headerLayoutWay == '0'){
        this.tableList[0].tips = '表头表尾的宽度是指两个字段之间的间距，宽度1代表1个字符的宽度，-1代表强制换行。'
      }
      this.getTemplateType()
      this.getPrintHeadTemplate()
      // this.getPrintTemplate()
    },
    async getPrintHeadTemplate() {
      this.printHeadTemplateLoading = true
      const { data: res } = await this.$http.post('/Account/PrintSet/selectPrintHeadTemplate.html', this.Qs.stringify({
        printSetType: this.templateForm.printSetType
      }))
      this.printHeadTemplateLoading = false
      if (res.code != '0') return this.$alert(res.msg, '提示', {
        confirmButtonText: '确定'
      })
      this.templateForm = {...this.templateForm, ...res.data}
      this.templateForm.headColspan = Number(this.templateForm.headColspan)
      this.templateForm.footerColspan = Number(this.templateForm.footerColspan)
      let pageSet = this.pageSetList.filter(i => i.width == res.data.printLodopWidth && i.height == res.data.printLodopHeight)
      if (pageSet.length) {
        this.templateForm.pageSet = pageSet[0]
      } else {
        this.templateForm.pageSet = this.pageSetList[0]
        this.templateForm.pageSet.width = res.data.printLodopWidth
        this.templateForm.pageSet.height = res.data.printLodopHeight
      }
      console.log(res)
      this.getPrintTemplate()
    },
    async getPrintTemplate() {
      this.tableLoading = true
      const { data: res } = await this.$http.post('/Account/PrintSet/selectPrintTemplate.html', this.Qs.stringify({
        printSetType: this.templateForm.printSetType
      }))
      this.tableLoading = false
      let tableList = [
        {
          id: 'head',
          tag: '表头字段设置',
          tips: '',
          isRoot: true,
          children: []
        },
        {
          id: 'body',
          tag: '表格字段设置',
          tips: '',
          isRoot: true,
          children: []
        },
        {
          id: 'footer',
          tag: '表尾字段设置',
          tips: '',
          isRoot: true,
          children: []
        }
      ]
      if(this.templateForm.headerLayoutWay == '0'){
        tableList[0].tips = '表头表尾的宽度是指两个字段之间的间距，宽度1代表1个字符的宽度，-1代表强制换行。'
      }
      res.rows.forEach((item, $index) => {
        if (item.printColumnType == 'H') {
          let index = tableList.findIndex($item => $item.id == 'head')
          // item.id = 'head_' + item.indexNum
          item.id = 'head_' + $index
          item.$index = $index + 1
          tableList[index].children.push(item)
        } else if (item.printColumnType == 'T') {
          let index = tableList.findIndex($item => $item.id == 'body')
          // item.id = 'body_' + item.indexNum
          item.id = 'body_' + $index
          item.$index = $index + 1
          tableList[index].children.push(item)
        } else if (item.printColumnType == 'F') {
          let index = tableList.findIndex($item => $item.id == 'footer')
          // item.id = 'footer_' + item.indexNum
          item.id = 'footer_' + $index
          item.$index = $index + 1
          tableList[index].children.push(item)
        }
      })
      this.tableList = [...tableList]
      this.$nextTick(() => {
        this.$refs.centerTable.doLayout()
      })
      this.$nextTick(() => {
        this.$refs.previewTable.doLayout()
      })
    },
    arraySpanMethod({ row }) {
      if (row.isRoot) {
        return [1, 7];
      }
    },
    tableCellClick(row, { property }) {
      if (row.isRoot || !['printColumnName', 'width', 'indexNum', 'fontsize'].includes(property)) return false
      this.$set(row, 'is' + titleCase(property), true)
    },
    inputBlur(row, { property }, event) {
      this.$set(row, 'is' + titleCase(property), false)
    },
    addWidthBlur(row, event){
      this.$set(row, 'width', event.target.value)
    },
    headerDragend(newWidth, oldWidth, {property}) {
      this.tableList[1].children.forEach(item => {
        if (item.printColumnValue == property) {
          item.width = newWidth
        }
      })
    },
    async onSubmit(tag) {
      let params = {...this.templateForm}
      let tableList = []
      this.tableList.forEach(item => {
        tableList = tableList.concat(item.children)
      })
      params.detailStr = JSON.stringify(tableList)
      delete params.pageSet
      const { data: res } = await this.$http.post('/Account/PrintSet/addPrintTemplate.html', this.Qs.stringify(params))
      if (!res.success) return this.$alert(res.msg, '提示', {
        confirmButtonText: '确定'
      })
      this.$message({
        type: 'success',
        message: res.msg
      });
      this.getPrintHeadTemplate()
      // this.getPrintTemplate()
      if (tag == 1) {
        window.open(`/Account/PrintSet/printDemo.html?printSetType=${params.printSetType}`,'_blank',"width=1011,height=680,left=300,top=150,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,location=no")
      }
    },
    async getOverallSet() {
      this.controlFormLoading = true
      const { data: res } = await this.$http.post('/Account/_public/printGlobalParam.html')
      this.controlFormLoading = false
      if (res.code != '0') return this.$alert(res.msg, '提示', {
        confirmButtonText: '确定'
      })
      this.controlForm = {...this.controlForm, ...res.data}
      let pageSet = this.pageSetList.filter(i => i.width == res.data.printLodopWidth && i.height == res.data.printLodopHeight)
      if (pageSet.length) {
        this.controlForm.pageSet = pageSet[0]
      } else {
        this.controlForm.pageSet = this.pageSetList[0]
        this.controlForm.pageSet.width = res.data.printLodopWidth
        this.controlForm.pageSet.height = res.data.printLodopHeight
      }
    },
    async saveSet() {
      let params = {...this.controlForm}
      delete params.pageSet
      const { data: res } = await this.$http.post('/Account/_public/updatePrintGlobalParam.html', this.Qs.stringify(params))
      if (!res.success) return this.$alert(res.msg, '提示', {
        confirmButtonText: '确定'
      })
      this.$message({
        type: 'success',
        message: res.msg
      });
      this.getOverallSet()
    },
    async useDefaultTemplate() {
      const confirmResult = await this.$confirm('是否重置为默认模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消重置')
      const loading = this.$loading({
        lock: true,
        text: '重置中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let printSetType = this.templateForm.printSetType
      const { data: res } = await this.$http.post('/Account/PrintSet/resetPrintTemplate.html', this.Qs.stringify({printSetType, isNewPrint: 'Y'}))
      loading.close()
      if (!res.success) return this.$alert(res.msg, '提示', {
        confirmButtonText: '确定'
      })
      this.$message({
        type: 'success',
        message: res.msg
      });
      this.getPrintHeadTemplate()
      // this.getPrintTemplate()
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  height: 100%;
  ::v-deep .el-tabs {
    height: calc(100% - 2px);
    #tab-2 {
      color: #F56C6C;
      font-size: 18px;
      font-weight: 700;
      margin-left: 20px;
    }
    .el-tabs__content {
      height: calc(100% - 40px);
      box-sizing: border-box;
      .el-tab-pane,.el-container {
        height: 100%;
      }
    }
    .el-form {
      .el-form-item {
        margin-bottom: 12px;
        .tips {
          position: relative;
          height: 100%;
          margin-bottom: 16px;
        }
        .append {
          margin: 0 6px;
        }
      }
    }
    #pane-global {
      .el-form {
        height: 100%;
      }
    }
    .el-scrollbar {
      height: 100%;
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .el-scrollbar__bar {
        z-index: 999;
      }
    }
    .el-aside {
      height: 100%;
      .templateForm {
        box-sizing: border-box;
        padding: 10px 6px;
        height: calc(100% - 2px);
        overflow: hidden;
        .el-form-item__label {
          line-height: 24px;
        }
      }
    }
    .el-main {
      height: 100%;
      padding: 0 12px;
      display: flex;
      .mainTable {
        height: 100%;
        .el-card {
          .el-card__body {
            padding: 6px;
          }
        }
        .table {
          height: calc(100% - 50px);
          .el-table__indent,
          .el-table__placeholder {
            display: none;
            padding: 0 !important;
          }
          .el-table {
            display: inline-block;
            min-width: 688px;
          }
        }
      }
      .preview {
        position: relative;
        width: calc(241px * 3.77);
        display: inline-block;
        margin-left: 12px;
        .previewLine {
          position: absolute;
          top: 0;
          left: 0;
          box-sizing: border-box;
          border: 1px #409EFF solid;
          z-index: 1;
        }
        .el-table__header-wrapper {
          position: relative;
          z-index: 2;
        }
        .el-table--scrollable-x .el-table__body-wrapper {
          z-index: 2;
        }
      }
    }
  }
  .print-name {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #303133;
    background: #fafafa;
    border: 1px solid #ebeef5;
  }
  .print-value {
    margin-left: 10px;
    font-size: 14px;
    color: #606266;
  }
}
</style>